export default __webpack_public_path__ + "static/media/twitter.7f34a601.svg";